import { useCommonStore } from "@/store/pinia/common";

type CiAPIHeaders = {
    "Content-Type": string;
    Authorization?: string;
};

export function getBaseApiUrl() {
    try {
        const commonStore = useCommonStore();

        return commonStore.baseApiURL;
    } catch {
        throw new Error("Failed to get base API URL");
    }
}

export function getDefaultHeaders(authorizationHeader: string | null): CiAPIHeaders {
    return {
        "Content-Type": "application/json",
        ...(authorizationHeader ? { Authorization: authorizationHeader } : {})
    };
}

const BASE_REQUEST_OPTIONS = {
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    referrerPolicy: "no-referrer" // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
} as Partial<RequestInit>;

export async function request<T, B = unknown>(
    url: string,
    headers: CiAPIHeaders,
    method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
    body: B | undefined = undefined
) {
    const params: RequestInit = {
        method,
        headers,
        ...BASE_REQUEST_OPTIONS,
        ...(body ? { body: JSON.stringify(body) } : {})
    };

    const resp = await fetch(url, params);

    if (!resp.ok) {
        const { message } = (await resp.json()) as { message?: string };

        if (message) {
            throw new Error(message);
        }

        throw new Error("Something went wrong");
    }

    return resp.json() as Promise<{ data: T }>;
}

export * from "./resourceManager";
export * from "./plainly";
